import { format } from 'date-fns';
import DOMPurify from 'dompurify';
import { isMoment } from 'moment';
import get from 'lodash/get';

import { DateMoment } from 'contexts/FormProvider';
import { SEPARATOR } from './constants';
import { DECIMAL_SCALE } from 'config';

export const DATE_FORMAT = 'dd/MM/yyyy';

const LOCALE = 'en-AU';

export const formatDate = (date: DateMoment) =>
  date !== null && format(isMoment(date) ? date.toDate() : date, DATE_FORMAT);

export const transformedCheckboxValue = (data: string[]) =>
  (data || []).reduce((acc: object, curr: string) => {
    const [category, value]: string[] = curr.split(SEPARATOR);
    return {
      ...acc,
      [category]: typeof get(acc, category) === 'undefined' ? [value] : [...get(acc, category), value],
    };
  }, {});

interface CategorySelected {
  category: string;
  selected: string[];
}

export const transformedCheckboxValueCategorized = (data: string[]) =>
  data.reduce((acc: CategorySelected[], curr: string) => {
    const [category, value]: string[] = curr.split(SEPARATOR);

    const catIndex = acc.findIndex((cat: CategorySelected) => cat.category === category);
    const isCategoryExists = catIndex >= 0;
    if (isCategoryExists) {
      const newAcc = acc;
      newAcc[catIndex] = {
        ...newAcc[catIndex],
        selected: [...newAcc[catIndex].selected, value],
      };

      return newAcc;
    }

    return [
      ...acc,
      {
        category: category,
        selected: [value],
      },
    ];
  }, []);

export const toNumber = (value: string | number | null, withComma = false) => {
  if (value === null) {
    return null;
  }

  const numValue = typeof value === 'string' ? Number(value.replace(/,/g, '')) : value;

  return Number(numValue).toLocaleString(LOCALE, {
    minimumFractionDigits: DECIMAL_SCALE,
    maximumFractionDigits: DECIMAL_SCALE,
    useGrouping: withComma,
  });
};

export const toExpenseArray = (obj: object) =>
  Object.entries(obj).map(([key, value]) => ({
    expense_type: key,
    expense_amount_per_month: toNumber(value),
  }));

export const isObjectContainsXss = (obj: object) =>
  Object.values(obj).some(
    (value) => typeof value === 'string' && value !== DOMPurify.sanitize(value, { ALLOWED_TAGS: [] })
  );
